import(/* webpackMode: "eager" */ "/home/runner/work/offer-tool-international/offer-tool-international/apps/frontend/src/app/[locale]/error.tsx");
